module.exports = __webpack_public_path__ + "static/img/manual-1.2a3c8bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-1.png
// module id = qA8x
// module chunks = 4